export const recommendationFileTypes = {
  report: { ja: "調査書", en: "School Report / Transcript" },
  rec1: { ja: "推薦状１", en: "Rec Letter 1" },
  rec2: { ja: "推薦状２", en: "Rec Letter 2" },
  rec3: { ja: "留学中の調査書", en: "Transcript while abroad" },
};
